//@flow
import type { ThunkAction } from '../../core/types'
import { services } from '../../core/feathers'
import {
  CONNECT_CHARITY_RESOURCE,
  CONNECT_CHARITY_REQUEST,
  CONNECT_CHARITY_SUCCESS,
  CONNECT_CHARITY_FAILED
} from './constants'
import {
  isCharityConnecting,
  isCharityConnectedOK,
  isCharityConnectedFailed
} from './selectors'
import { batch } from '../../modules/lib/batchReducer'
import {
  startCommunication,
  endCommunication
} from '../../modules/communication/index'

export function connectWithAccount(code: string): ThunkAction {
  return async function(dispatch, getState) {
    const state = getState()
    if (
      isCharityConnecting(state) ||
      isCharityConnectedOK(state) ||
      isCharityConnectedFailed(state)
    ) {
      return {
        pending: true
      }
    }
    dispatch(
      batch(
        CONNECT_CHARITY_REQUEST,
        startCommunication(CONNECT_CHARITY_RESOURCE)
      )
    )
    try {
      const response = await services.stripeAccounts.create({ code })
      console.log('Account create response', response)
      dispatch(
        batch(
          CONNECT_CHARITY_SUCCESS,
          endCommunication(CONNECT_CHARITY_RESOURCE, true)
        )
      )
      return {
        success: true
      }
    } catch (error) {
      console.warn('Error creating stripeAccount', error)
      dispatch(
        batch(
          CONNECT_CHARITY_FAILED,
          endCommunication(CONNECT_CHARITY_RESOURCE, false)
        )
      )
      return {
        success: false,
        message: error.message
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/stripe/actions.js